import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { HardwarePackagesListPage } from './routes/list/Page';
import { QueryBuilderPage } from './routes/query-builder/Page';

export const HardwarePackagesRouter = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <HardwarePackagesListPage />
      </Route>
      <Route path={`${path}/:id/query-builder`}>
        <QueryBuilderPage />
      </Route>
    </Switch>
  );
};
